<template>
  <v-dialog :value="dialogProp.show" persistent max-width="600">
    <v-card class="elevation-4">
      <v-toolbar :dark="$vuetify.theme.dark" color="primary">
        <v-toolbar-title>
          {{ $t('Мой профиль') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="text-left pt-3">
        <v-row>
          <text-view
              :display="profile.contactPerson"
              multiline
              md="6"
              :label="$t('Контактное лицо')"
              prepend-icon="person" />
          <text-view
              :display="profile.phone"
              multiline
              md="6"
              :label="$t('Контактный телефон')"
              prepend-icon="settings_phone" />
          <text-view
              :display="profile.email"
              multiline
              md="6"
              label="Email"
              prepend-icon="alternate_email" />

          <date-view
              :display="currentUserExpirationsDates.totalExpirationDate"
              multiline
              md="6"
              :label="$t('Доступ разрешен до')"
              prepend-icon="admin_panel_settings"
              date-format="DD.MM.YYYY HH:mm" />
          <text-view
              v-if="profile.subscriptionsStatus"
              multiline
              md="6"
              :display="$t(SUBSCRIPTIONS_TYPE_ENUM[profile.subscriptionsStatus])"
              :label="$t('Подписка на рассылку')"
              prepend-icon="mail" />
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
            id="cancelBtn"
            v-test="{ btn: 'cancel' }"
            color="primary"
            @click.stop="cancel">
          {{ $t('Закрыть') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import TextView from '@/components/reused/ui/TextView.vue'
  import DateView from '@/components/reused/ui/DateView.vue'
  import { SUBSCRIPTIONS_TYPE_ENUM } from '@/constants/enums'
  import { mapState, mapActions } from 'vuex'
  import { CURRENT_USER, CURRENT_USER_EXPIRATIONS_DATES } from '@/constants/store.js'

  export default {
    components: {
      TextView,
      DateView
    },
    props: {
      dialogProp: {
        type: Object,
        default: () => {
          return {
            show: false
          }
        }
      }
    },
    data () {
      return {
        SUBSCRIPTIONS_TYPE_ENUM
      }
    },
    computed: {
      ...mapState(CURRENT_USER.NAMESPACE, {
        profile: state => (state || {})
      }),
      ...mapState(CURRENT_USER_EXPIRATIONS_DATES.NAMESPACE, {
        currentUserExpirationsDates: state => (state || {})
      })
    },
    created: function () {
      Promise.all([
        this.getCurrentUserInfo(),
        this.getExpirationDates()
      ])
    },
    methods: {
      ...mapActions(CURRENT_USER_EXPIRATIONS_DATES.NAMESPACE, {
        getExpirationDatesAction: CURRENT_USER_EXPIRATIONS_DATES.ACTIONS.GET_EXPIRATION_DATES
      }),
      getExpirationDates: async function () {
        try {
          await this.getExpirationDatesAction()
        } catch (error) {
          this.throwIfNotServerError(error)
        }
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
